import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DadosProposta } from '../models/dados-proposta.model';
import { PROPOSTA_FINANCIAMENTO_REPOSITORY, PropostaFinanciamentoRepository } from '../repositories/proposta-financiamento.repository';

@Injectable({
  providedIn: 'root'
})
export class SalvarRascunhoDadosPropostaUseCase {
  constructor(
    @Inject(PROPOSTA_FINANCIAMENTO_REPOSITORY) private readonly repository: PropostaFinanciamentoRepository
  ) {}

  execute(matricula: string, dados: DadosProposta): Observable<DadosProposta> {
    return this.repository.salvarRascunhoDadosPropostaManual(matricula, dados);
  }
}
